import state from "./state";
import * as getters from "./getters";
import * as mutations from "./mutations";
import * as actions from "./actions";
import meshes from "./meshes";
import wiki from "./wiki";
export default {
  modules: {
    meshes: meshes,
    wiki: wiki
  },
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};